import { api } from "../configs/apiConfig";

// Bonus Type Services
export const getBonusTypes = async () => {
  try {
    const response = await api.get("/BonusType");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch bonus types:", error.response?.data || error.message);
    throw error;
  }
};

export const getBonusTypeById = async (id) => {
  try {
    const response = await api.get(`/BonusType/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch bonus type:", error.response?.data || error.message);
    throw error;
  }
};

export const createBonusType = async (bonusTypeData) => {
  try {
    const response = await api.post("/BonusType", bonusTypeData);
    return response.data;
  } catch (error) {
    console.error("Failed to create bonus type:", error.response?.data || error.message);
    throw error;
  }
};

export const updateBonusType = async (id, bonusTypeData) => {
  try {
    const response = await api.put(`/BonusType/${id}`, bonusTypeData);
    return response.data;
  } catch (error) {
    console.error("Failed to update bonus type:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteBonusType = async (id) => {
  try {
    await api.delete(`/BonusType/${id}`);
    return true;
  } catch (error) {
    console.error("Failed to delete bonus type:", error.response?.data || error.message);
    throw error;
  }
};

// Bonus Request Services
export const getAllBonusRequests = async () => {
  try {
    const response = await api.get("/BonusRequest");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch bonus requests:", error.response?.data || error.message);
    throw error;
  }
};

// Get requests for a specific user
export const getUserBonusRequests = async (userId) => {
  try {
    const response = await api.get(`/BonusRequest/my?userId=${userId}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch user bonus requests:", error.response?.data || error.message);
    throw error;
  }
};

// Get requests created by a specific user
export const getCreatedBonusRequests = async (userId) => {
  try {
    const response = await api.get(`/BonusRequest/created?userId=${userId}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch created bonus requests:", error.response?.data || error.message);
    throw error;
  }
};

export const getBonusRequestById = async (id) => {
  try {
    const response = await api.get(`/BonusRequest/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch bonus request:", error.response?.data || error.message);
    throw error;
  }
};

export const createBonusRequest = async (requesterId, bonusRequestData) => {
  try {
    // Ensure requesterId is a number
    const numericRequesterId = parseInt(requesterId);
    if (isNaN(numericRequesterId)) {
      throw new Error('Invalid requesterId');
    }

    // Format the request data
    const formattedData = {
      bonusTypeId: parseInt(bonusRequestData.bonusTypeId),
      amount: parseFloat(bonusRequestData.amount),
      reason: bonusRequestData.reason,
      userId: parseInt(bonusRequestData.userId)
    };

    console.log('Making request to:', `/BonusRequest/${numericRequesterId}`);
    console.log('Request data:', formattedData);
    console.log('Headers:', api.defaults.headers);

    const response = await api.post(`/BonusRequest/${numericRequesterId}`, formattedData);
    return response.data;
  } catch (error) {
    // Extract the most meaningful error message
    const errorMessage = error.response?.data?.message || 
                        error.response?.data || 
                        error.message || 
                        'Failed to create bonus request';
    console.error("Bonus request error details:", {
      message: errorMessage,
      status: error.response?.status,
      data: error.response?.data,
      headers: error.response?.headers
    });
    throw new Error(errorMessage);
  }
};

export const createBonusRequestForUser = async (requesterId, bonusRequestData) => {
  try {
    const response = await api.post(`/BonusRequest/byRequester/${requesterId}`, bonusRequestData);
    return response.data;
  } catch (error) {
    console.error("Failed to create bonus request for user:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteBonusRequest = async (id) => {
  try {
    await api.delete(`/BonusRequest/${id}`);
    return true;
  } catch (error) {
    console.error("Failed to delete bonus request:", error.response?.data || error.message);
    throw error;
  }
};

export const processBonusRequest = async (id, processorId, processData) => {
  try {
    const response = await api.post(`/BonusRequest/${id}/process?processorId=${processorId}`, processData);
    return response.data;
  } catch (error) {
    console.error("Failed to process bonus request:", error.response?.data || error.message);
    throw error;
  }
};

export const cancelBonusRequest = async (id, processorId) => {
  try {
    // To cancel a request, we use the process endpoint with 'Cancel' action
    const response = await api.post(`/BonusRequest/${id}/process?processorId=${processorId}`, {
      action: "Cancel",
      comments: "Cancelled by requester"
    });
    return response.data;
  } catch (error) {
    console.error("Failed to cancel bonus request:", error.response?.data || error.message);
    throw error;
  }
};

const bonusService = {
  // Bonus Types
  getBonusTypes,
  getBonusTypeById,
  createBonusType,
  updateBonusType,
  deleteBonusType,
  
  // Bonus Requests
  getAllBonusRequests,
  getUserBonusRequests,
  getCreatedBonusRequests,
  getBonusRequestById,
  createBonusRequest,
  createBonusRequestForUser,
  deleteBonusRequest,
  processBonusRequest,
  cancelBonusRequest
};

export default bonusService; 